import { render } from "./District.vue?vue&type=template&id=75a1e226&scoped=true"
import script from "./District.vue?vue&type=script&lang=js"
export * from "./District.vue?vue&type=script&lang=js"

import "./District.vue?vue&type=style&index=0&id=75a1e226&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a1e226"]])

export default __exports__